import { useMemo } from "react";
import { useNavigation } from '@react-navigation/native';
import GameHelper from "../game/GameHelper";

export function useHffeNavigation(navigation) {
    navigation = navigation || useNavigation();
    return useMemo(() => new HffeNavigation(navigation), [navigation]);
}


export class HffeNavigation {
    constructor(navigation) {
        this.navigation = navigation;
    }

    gotoMessagesArgs({ game, hasUnreadChatMessages, username } = {}) {
        let toUsername = null;

        if (username) {
            toUsername = username;
        } else {
            const otherPlayers = game ? GameHelper.getOtherHumanPlayers(game) : null;
            toUsername = otherPlayers?.length === 1 ? otherPlayers[0].userAccount.username : undefined;
        }

        const params = {
            fromGame: game ? game.alphanumericId : undefined,
            toUsername,
            forceGotoUnreadChat: hasUnreadChatMessages ? true : undefined,
        };

        return ['Home', { screen: 'Messages', params }];
    }

    gotoMessages(args) {
        return this.navigation.navigate(...this.gotoMessagesArgs(args));
    }
}